<template>
    <div>
        logging out
    </div>
</template>

<script>
    export default {
        name: "Logout",
        created() {
            this.$store.dispatch('removeToken').then(() => {
                this.$router.push({name: 'home'}).catch(e => {
                    // eslint-disable-next-line no-console
                    console.log(e)
                })
            })
        },
    }
</script>

<style scoped>

</style>